<template>

<com-item name="game.plays.overview" :size="size" :is-overview="3" :loading="loading" :is-empty="!active" title="Overview">

	<template v-slot:about>

		<p>Summary of {{ your }} play history with this game.</p>

	</template>

	<template v-slot:stats>

		<com-overview label="Total Plays" type="number" :value="data.totalPlays" />

		<com-overview label="First Played" type="date" :value="data.firstPlayed" v-if="data.firstPlayed" />
		<com-overview label="First Played" type="number" :empty="true" v-if="!data.firstPlayed" />

		<com-overview label="Last Played" type="date" :value="data.lastPlayed" v-if="data.lastPlayed" />
		<com-overview label="Last Played" type="number" :empty="true" v-if="!data.lastPlayed" />

		<com-overview label="Monthly Average" type="number" :value="monthlyAverage" v-if="monthlyAverage" />
		<com-overview label="Monthly Average" type="number" :empty="true" v-if="!monthlyAverage" />

		<com-overview label="Win Rate" type="percent" :value="data.winRate" v-if="data.winRate !== null" />
		<com-overview label="Win Rate" type="number" :empty="true" v-if="data.winRate === null" />

		<com-overview label="Months Active" type="number" :value="playsData.totalPlayed" :value-label="'of ' + playsData.totalMonths" v-if="playsData.totalMonths" />
		<com-overview label="Months Active" type="number" :empty="true" v-if="!playsData.totalMonths" />

		<com-overview label="Total Hours" type="number" :value="totalHours" v-if="data.totalPlayTime" />
		<com-overview label="Total Hours" type="number" :empty="true" v-if="!data.totalPlayTime" />

		<com-overview label="Avg Duration" type="number" :value="avgDurationValue" :value-label="avgDurationUnit" v-if="data.avgPlayTimePerSession" />
		<com-overview label="Avg Duration" type="number" :empty="true" v-if="!data.avgPlayTimePerSession" />

		<com-overview label="Total Players" type="number" :value="data.totalPlayers" v-if="data.totalPlayers" />
		<com-overview label="Total Players" type="number" :empty="true" v-if="!data.totalPlayers" />

	</template>

</com-item>

</template>

<script>

import comOverview from './../common/Overview'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/game/overview']

		},

		playsData: function() {

			return this.$store.getters['page/insights/game/plays']

		},

		totalHours: function() {

			if (!this.data || !this.data.totalPlayTime) return 0
			return Math.round(this.data.totalPlayTime / 60 * 10) / 10

		},

		monthlyAverage: function() {

			if (!this.playsData || !this.playsData.totalMonths || !this.data || !this.data.totalPlays) return 0
			return Math.round((this.data.totalPlays / this.playsData.totalMonths) * 100) / 100

		},

		avgDurationValue: function() {

			if (!this.data || !this.data.avgPlayTimePerSession) return 0
			var mins = this.data.avgPlayTimePerSession
			if (mins >= 60) return Math.round((mins / 60) * 10) / 10
			return mins

		},

		avgDurationUnit: function() {

			if (!this.data || !this.data.avgPlayTimePerSession) return ''
			return this.data.avgPlayTimePerSession >= 60 ? 'hours' : 'minutes'

		},

		active: function() {

			return this.data && !this.loading && Object.keys(this.data).length

		}

	}

}

</script>

<style scoped>

</style>
